/* Alpha Elements — cookie banner on top of Shopify's Customer Privacy API.
   Shopify decides whether consent is required for the visitor's region (shouldShowBanner); the choice is stored by Shopify
   and respected by Shopify Analytics, Web Pixels and apps (e.g. Google & YouTube). Optional GA4 loads only with analytics consent. */
(() => {
  'use strict';
  const S = window.AE_SETTINGS || {};
  const bar = document.getElementById('consent'), modal = document.getElementById('consent-modal');
  const st = document.getElementById('cm-statistik'), mk = document.getElementById('cm-marketing');
  window.dataLayer = window.dataLayer || [];
  const AE = window.AE = window.AE || {};
  let cp = null, gaLoaded = false;

  AE.track = (event, params = {}) => {
    window.dataLayer.push({ event, ...params });
    try { window.Shopify?.analytics?.publish?.('ae_' + event, params); } catch (e) {}
    if (gaLoaded && window.gtag) window.gtag('event', event, params);
  };

  function loadGA() {
    if (gaLoaded || !S.ga4 || !cp?.analyticsProcessingAllowed?.()) return;
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: cp.marketingAllowed() ? 'granted' : 'denied', ad_user_data: cp.marketingAllowed() ? 'granted' : 'denied', ad_personalization: cp.marketingAllowed() ? 'granted' : 'denied' });
    const s = document.createElement('script'); s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(S.ga4); document.head.appendChild(s);
    gtag('js', new Date()); gtag('config', S.ga4); gaLoaded = true;
  }
  function decided() { const c = cp?.currentVisitorConsent?.() || {}; return c.analytics === 'yes' || c.analytics === 'no' || c.marketing === 'yes' || c.marketing === 'no'; }
  const KEY = 'ae_consent';
  const stored = () => { try { const v = JSON.parse(localStorage.getItem(KEY)); return v && Date.now() - v.t < 365 * 864e5 ? v : null; } catch (e) { return null; } };
  function save(stat, mkt) {
    bar && (bar.hidden = true); modal && (modal.hidden = true);
    try { localStorage.setItem(KEY, JSON.stringify({ a: !!stat, m: !!mkt, t: Date.now() })); } catch (e) {}
    if (!cp) return;
    cp.setTrackingConsent({ analytics: !!stat, marketing: !!mkt, preferences: !!stat, sale_of_data: !!mkt }, () => { loadGA(); AE.track('consent_update', { statistik: !!stat, marketing: !!mkt }); });
  }
  function openSettings() { const c = cp?.currentVisitorConsent?.() || {}; if (st) st.checked = c.analytics === 'yes'; if (mk) mk.checked = c.marketing === 'yes'; if (modal) { modal.hidden = false; setTimeout(() => st?.focus(), 50); } }

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-consent],[data-open-consent]'); if (!b) return;
    e.preventDefault();
    if (b.matches('[data-open-consent]')) return openSettings();
    const a = b.dataset.consent;
    if (a === 'all') save(true, true); else if (a === 'none') save(false, false);
    else if (a === 'settings') openSettings(); else if (a === 'save') save(st?.checked, mk?.checked);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal && !modal.hidden) { modal.hidden = true; if (cp?.shouldShowBanner?.() && !decided()) bar.hidden = false; } });

  function init() {
    cp = window.Shopify?.customerPrivacy;
    if (!cp) return;
    const prev = stored();
    if (!decided() && prev) cp.setTrackingConsent({ analytics: prev.a, marketing: prev.m, preferences: prev.a, sale_of_data: prev.m }, loadGA);
    else if (cp.shouldShowBanner() && !decided() && bar) bar.hidden = false;
    loadGA();
    if (/\/products\//.test(location.pathname)) AE.track('view_item', { path: location.pathname });
  }
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => { if (!err) init(); });
  } else {
    addEventListener('load', () => window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], err => { if (!err) init(); }));
  }
})();
